module.exports = __webpack_public_path__ + "media/images/flags/ch-b75d28391692c79b3520d43e34d7f566.svg";